// extracted by mini-css-extract-plugin
export var cardIcon = "_4t-4";
export var checkboxCard = "_4t-0";
export var checkboxCardSelected = "_4t-1";
export var disabled = "_4t-2";
export var outerBorder = "_4t-3";
export var spacerMedium = "_4t-7";
export var spacerSmall = "_4t-6";
export var spacerXsmall = "_4t-5";